import { getMatchingAttributeConfig } from "api/getMatchingAttributeConfig";
import { getPhotoAndCaptions, PhotoAndCaption } from "api/getPhotoAndCaptions";
import { Photo } from "api/types/photo";
import { SiteSurvey } from "api/types/siteSurvey";
import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";
import { SiteSurveyUnit } from "api/types/siteSurveyUnit";
import amazonLogo from "./AmazonLogo.png";
export function getPhotos(count: number): Photo[] {
  const photos: Photo[] = [];
  for (let index = 0; index < count; index++) {
    photos.push({
      originalPath: "",
      typeId: 1,
      temporaryPath: "",
      thumbnailPath: amazonLogo,
      id: 0,
    });
  }

  return photos;
}

export function getUnits(count: number) {
  const units: SiteSurvey["units"] = [];

  for (let index = 0; index < count; index++) {
    units.push({
      id: index,
      modelNumber: `Model ${index}`,
      photos: getPhotos(5),
      rtu: `${index}`,
      serialNumber: `Serial ${index}`,
      attributes: [],
    });
  }

  return units;
}

export function getUnitTitle(unit: SiteSurveyUnit): string {
  return `RTU ${unit.rtu}`;
}

export function getUnitPhotoCaptionPairs(
  unit: SiteSurveyUnit,
  config: SiteSurveyConfiguration
) {
  const photoCaptionPairs: PhotoAndCaption[] = [];

  for (const attribute of unit.attributes) {
    if (attribute.photo) {
      const matchingAttribute = getMatchingAttributeConfig(
        config.unitConfiguration.attributes,
        attribute
      );
      photoCaptionPairs.push({
        caption: matchingAttribute.text,
        photo: attribute.photo,
      });
    }
  }

  const unitPhotoTypePairs = getPhotoAndCaptions(
    config.unitConfiguration.photoTypes,
    unit.photos
  );

  const combined = [...unitPhotoTypePairs, ...photoCaptionPairs];
  return combined;
}
